<template>
  <router-link
    :to="{name: 'rush_info', params: {rushId: rushId}}"
  ><slot>{{text}}</slot></router-link>
</template>

<script>
export default {
  name: 'RushLink',

  props: {
    rushId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'rush',
    }
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.rushId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
